/**
 * SIGFU REST API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NationaliteDto } from './nationaliteDto';
import { TypeUserDto } from './typeUserDto';
import { PieceIdentiteDto } from './pieceIdentiteDto';
import { UserAdministrateurDto } from './userAdministrateurDto';
import { UserProfessionnelDto } from './userProfessionnelDto';
import { StatutCompteDto } from './statutCompteDto';
import { GenreDto } from './genreDto';


export interface UserDto { 
    forceUpdatePassword: boolean;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    email?: string;
    phone?: string;
    profil: string;
    dateNaissance: string;
    adresse: string;
    pieceIdentite: PieceIdentiteDto;
    nationalite: NationaliteDto;
    genre: GenreDto;
    typeUser: TypeUserDto;
    userAdministrateur?: UserAdministrateurDto;
    userProfessionnel?: UserProfessionnelDto;
    statutCompte: StatutCompteDto;
    dateDebutActivation: string;
    dateFinActivation: string;
    dateDerniereReactivation?: string;
    lieuNaissance: string;
    phoneType: string;
    phone2: string;
    phoneType2: string;
    carteProfessionnelle?: string;
    denomination?: string;
    noRegistreCommerce?: string;
    siegeSocial?: string;
    lieuEtablissement?: string;
    civiliteRepresentant?: string;
    noCompteContribuable?: string;
    dateCreation?: string;
    paysOrigine?: NationaliteDto;
    typeSociete?: string;
    capitalSociete?: string;
    nomAPBEF?: string;
    codeAPBEF?: string;
    noCarteProfessionnelle?: string;
}

